/*
-------------------------------------------------------------------------------------
Authors         : Alinsonorin, John Myl B., Awi, Joseph Kahl L., Gozon, Daniel Allan
Date Created    : April 30, 2025
Folder          : src/components/homepage/index
File            : Homepage.tsx
Description     : 
    This component allows the user to access the homepage of the web app.
Copyright © 2025. All rights reserved.
-------------------------------------------------------------------------------------
*/




// Imports MUI Components
import {
  Box,
  Grid,
  Typography,
} from "@mui/material"

const FooterCredits = () => {

  const gridStylesContainer = {
    marginTop: "20px",
    padding: {
      xs: "0 30px 80px 30px", 
      sm: "0 30px 80px 30px", 
      md: "0 110px 80px 110px", 
      lg: "0 110px 80px 110px", 
      xl: "0 110px 80px 110px" 
    },
    width: "100%",
    borderTop: " 1px solid #FDF9F3",
    "& .MuiGrid-item": {
      display: "flex",
      justifyContent: "center",
    },
  } 

  const boxStylesContainer = {
    height: "100%",
    textAlign: "center",
    justifyContent: "center",
    borderRadius: "20px",
    backgroundColor: "transparent",
    padding: "50px 20px 0px 20px",
    margin: "0 10px",
  }

  const textStyles = {
    padding: "5px 10px",
  }


  return (
    <>
      {/*Grids */}
      <Grid
        container
        sx={gridStylesContainer}
      >
        <Grid size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }} item>

          <Box
            sx={boxStylesContainer}
          >

            <Typography
              gutterBottom
              variant="body2"
              component="div"
              sx={textStyles}
            >
              © 2025 VSDiamond Dental. All rights reserved.
            </Typography>
              
          </Box>

        </Grid>

      </Grid>
    </>
  )

}

export default FooterCredits;